/** Hide setting: blur exercise until the student/teacher clicks 👁. */

export function isExerciseHideEnabled(exercise) {
    return exercise?.assessment?.hide === true;
}

/**
 * Completed / checked work always stays visible.
 * Teacher review and “show solution” also bypass the blur.
 */
export function isExerciseHideForcedVisible(assignment, { reviewMode = false, showSolution = false } = {}) {
    if (reviewMode || showSolution) return true;
    if (!assignment) return false;
    const s = assignment.status;
    if (s === 'working' || s === 'assigned') return false;
    if (s === 'completed' || s === 'checked') return true;
    return !!assignment.completed_at;
}
